import { ITINERARY_NOT_FOUND } from '@web-platform/shared-universal-constants/src/fps404NotFoundRegex';

import type {
  SonarV3PayloadResponseSuccess,
  SonarV3PollPayloadResponse,
} from '@web-platform/shared-universal-types/src/network/types';

// sometimes Sonar doesn't have any details until the next poll
export const isEmptyItinerary = (response: SonarV3PayloadResponseSuccess) =>
  'itinerary' in response.body &&
  response.body.itinerary?.id === '' &&
  response.body.itinerary.pricingOptions?.length === 0;

export const isNullishItinerary = (response: SonarV3PayloadResponseSuccess) =>
  'itinerary' in response.body && !response.body.itinerary;

export const isSonarV3ItineraryNotFound = (response: SonarV3PollPayloadResponse) =>
  response.error &&
  response.status === 404 &&
  response.body?.message &&
  !!ITINERARY_NOT_FOUND.exec(response.body.message);
